import type { JSX } from "react";
import dsaLogo from "./images/dsa-logo.png";
import { cn } from "packages/dsaui/src/utils";

interface LogoProps {
  className?: string;
}

export const Logo = ({ className }: LogoProps): JSX.Element => {
  return (
    <img
      className={cn("h-15 w-auto", className)}
      alt="Democratic Socialists of America Logo"
      height={60}
      src={dsaLogo}
    />
  );
};

export default Logo;
